/**
 * Utility to flatten a nested route configuration into a single-level array.
 * Useful for breadcrumb generation, search indexing, or flat route mapping in React Router.
 */

import type { AppRoute } from '../../types/global.types';

/**
 * Flattens nested routes into a single array
 */
export const flattenRoutes = (routes: AppRoute[]): AppRoute[] => {
  return routes.reduce<AppRoute[]>((acc, route) => {
    acc.push({ ...route, children: undefined }); // push parent
    if (route.children) {
      acc.push(...flattenRoutes(route.children)); // push children recursively
    }
    return acc;
  }, []);
};
